import * as ko from "knockout";
import { components } from "knockout";

import { EmailComposerShellViewModel, type EmailComposerParams } from "./email-composer";
import EmailComposerTemplate from "./email-composer.html?raw";

import RecommendationsTemplateUI from "./templates/recommendations/ui.html?raw";
import ArtistReminderTemplateUI from "./templates/artist-reminder/ui.html?raw";
import HostReminderTemplateUI from "./templates/host-reminder/ui.html?raw";
import QuickMessageTemplateUI from "./templates/quick-message/ui.html?raw";

export { EmailComposerShellViewModel } from "./email-composer";
export { RecommendationsTemplateVM } from "./templates/recommendations/vm";
export { ArtistReminderTemplateVM } from "./templates/artist-reminder/vm";
export { HostReminderTemplateVM } from "./templates/host-reminder/vm";
export { QuickMessageTemplateVM } from "./templates/quick-message/vm";
export type { Lang, Localized, Section, LocalizedTemplate, EmailTemplateVM } from "./templates/types";

// Bootstrap does not support a `.modal` nested inside another `.modal`
// (the inner one stays trapped in the outer modal's stacking context, so it
// never appears and only leaves a stray backdrop behind). This binding moves
// the element out to <body> so a modal declared inside the composer modal's
// template ends up as a sibling of it and can stack normally.
if (!(ko.bindingHandlers as any).portalToBody) {
    (ko.bindingHandlers as any).portalToBody = {
        init(element: HTMLElement) {
            document.body.appendChild(element);
            ko.utils.domNodeDisposal.addDisposeCallback(element, () => {
                element.parentNode?.removeChild(element);
            });
        },
    };
}

if (!components.isRegistered("email-composer")) {
    components.register("email-tpl-recommendations", {
        viewModel: { createViewModel: (params: any) => params },
        template: RecommendationsTemplateUI,
    });

    components.register("email-tpl-artist-reminder", {
        viewModel: { createViewModel: (params: any) => params },
        template: ArtistReminderTemplateUI,
    });

    components.register("email-tpl-host-reminder", {
        viewModel: { createViewModel: (params: any) => params },
        template: HostReminderTemplateUI,
    });

    components.register("email-tpl-quick-message", {
        viewModel: { createViewModel: (params: any) => params },
        template: QuickMessageTemplateUI,
    });

    components.register("email-composer", {
        viewModel: {
            createViewModel: (params: EmailComposerParams) =>
                new EmailComposerShellViewModel(params),
        },
        template: EmailComposerTemplate,
    });
}
